import { Dialog, DialogTitle, DialogContent, DialogContentText, Breakpoint } from "@mui/material";
import { useTranslation } from 'react-i18next';
import DialogActionsButtons from "../DialogActionsButton";
import DialogTransition from "../DialogTransition";

interface ConfirmationDialogProps {
    opened: boolean;
    close?: () => void
    onConfirmation?: () => void;
    dialogTitle: string;
    dialogText?: string;
    closeOnConfirm?: boolean;
    confirmButtonText?: string;
    content?: JSX.Element[] | JSX.Element;
    maxWidth?: Breakpoint | false;
}

export default function ConfirmationDialog({ maxWidth, confirmButtonText, opened, close, onConfirmation, dialogTitle, dialogText, closeOnConfirm = true, content }: ConfirmationDialogProps) {
    const { t } = useTranslation();

    return (
        <>
            {opened &&
                <Dialog
                    maxWidth={maxWidth}
                    open={opened}
                    TransitionComponent={DialogTransition}
                    keepMounted
                    onClose={close}
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle>
                        {dialogTitle}
                    </DialogTitle>
                    <DialogContent>
                        {
                            dialogText &&
                            <DialogContentText sx={{ whiteSpace: 'pre-wrap' }}>
                                {dialogText}
                            </DialogContentText>
                        }
                        {content}
                        <DialogActionsButtons onClick={() => {
                            if (onConfirmation) {
                                onConfirmation();
                            }
                            if (closeOnConfirm && close) {
                                close();
                            }
                        }} buttonText={confirmButtonText ? confirmButtonText : t("confirm")} onClickCancel={close} />
                    </DialogContent>
                </Dialog>
            }
        </>
    );
}